import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button, IconArrowInbox } from '@sequencehq/core-components'
import { match } from 'ts-pattern'
import { useInvoicesCsvExport } from 'components/Invoices/useInvoicesCsvExport'
import { DownloadInvoicesGridCsvExportModal } from 'components/Invoices/InvoicesGrid/DownloadInvoicesGridCsvExportModal'
import { isValidCurrencyString } from '@sequencehq/utils'

type Props = {
  filtersApiQueryParams: string
}

export const InvoicesExportToCsv = ({ filtersApiQueryParams }: Props) => {
  const [searchParams] = useSearchParams()

  const view = searchParams.get('view')
  const currency = searchParams.get('currency')

  const { download } = useInvoicesCsvExport({ filtersApiQueryParams })

  const [showCsvExportModal, setShowCsvExportModal] = useState<boolean>(false)

  const buttonProps = {
    variant: 'secondary',
    leadingIcon: <IconArrowInbox color="inherit" />,
    'data-testid': 'invoices.exportToCsv'
  } as const

  if (!download.available) {
    return null
  }

  return match(view)
    .with('grid', () => {
      if (!currency || !isValidCurrencyString(currency)) {
        return null
      }

      return (
        <>
          <Button {...buttonProps} onClick={() => setShowCsvExportModal(true)}>
            Export to CSV
          </Button>

          {showCsvExportModal && (
            <DownloadInvoicesGridCsvExportModal
              currency={currency}
              onClose={() => setShowCsvExportModal(false)}
            />
          )}
        </>
      )
    })
    .otherwise(() => (
      <Button {...buttonProps} onClick={() => download.onClick()}>
        Export to CSV
      </Button>
    ))
}
